import axios from 'axios'
import endpoints from '@/api/endpoints'


export default {
  async createConstructionProject (obj) {
    return axios.post(endpoints.constructionProjects, obj).then((response) => {
      return response.data
    })
  },
  async updateConstructionProject (obj) {
    return axios.patch(endpoints.constructionProjects + obj.id + '/', obj).then((response) => {
      return response.data
    })
  },
  async getConstructionProjects () {
    return axios.get(endpoints.constructionProjects).then((response) => {
      return response.data
    })
  }
}